import { render, staticRenderFns } from "./PermissionsCard.vue?vue&type=template&id=ddd6d244&"
import script from "./PermissionsCard.vue?vue&type=script&lang=js&"
export * from "./PermissionsCard.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsCard.vue?vue&type=style&index=0&id=ddd6d244&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QCard,QForm,QCardSection,QCardActions,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QForm,QCardSection,QCardActions,QInnerLoading,QSpinnerTail})
